<script lang="ts">
	import { getProductPath } from "../../../../core/schema/paths/getProductPath.js";
	import { OrderStatus } from "../../../../core/schema/OrderStatus.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import cake from "../../../../core/assets/icons/cake.svg?raw";
	import Button from "../Button.svelte";
	import ProductImageWithCounter from "./ProductImageWithCounter.svelte";
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import type { OrderProduct } from "../../../../core/schema/OrderProduct.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import OrderProductCardOptions from "./OrderProductCardOptions.svelte";
	import logo from "../../../../core/assets/logo.png";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";

	export let imageByProductId: Record<string, UploadedFile>;
	export let product: ProductForCustomer;
	export let orderProduct: OrderProduct;
	export let orderStatus: OrderStatus;
	export let onRepeatOrder: () => Promise<void>;
	export let isAlone: boolean;
	export let isLast: boolean;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;
</script>

<div class="border-t-1 flex w-full flex-col justify-between gap-4 border-gray-200 p-4 md:p-6 lg:flex-row">
	<div class="flex flex-col gap-4 lg:flex-row">
		<div class="flex gap-2 md:gap-4">
			<ProductImageWithCounter
				image={imageByProductId[orderProduct.product.id] ?? logo}
				size={88}
				imgClass="min-w-[3.5rem] md:min-w-[5.5rem] md:w-[5.5rem] w-[3.5rem] md:h-[5.5rem] h-[3.5rem] object-contain"
				path={getProductPath(TENANT_LOCALE, orderProduct.product)}
				quantity={orderProduct.quantity}
			/>
			<p class="md:text-md self-start text-base font-semibold lg:hidden">{orderProduct.product.name[TENANT_LOCALE]}</p>
		</div>
		<div class="flex flex-col justify-between gap-3">
			<p class="text-md hidden self-start font-semibold lg:inline">
				{orderProduct.product.name[TENANT_LOCALE]}
			</p>
			<OrderProductCardOptions {orderStatus} {product} {orderProduct} {isAlone} />
		</div>
	</div>

	{#if [OrderStatus.Delivered, OrderStatus.Cancelled].includes(orderStatus) && isLast}
		<div class="hidden self-end text-nowrap lg:block">
			<Button variant="primary" icon={cake} iconClass="h-5 w-5" on:click={onRepeatOrder}>Znovu objednat</Button>
		</div>
	{:else if !isAlone}
		<p class="text-md hidden font-semibold lg:inline">
			{nbspify(formatPrice(orderProduct.product.price.withTax, TENANT_LOCALE, false))}
		</p>
	{/if}
</div>
{#if [OrderStatus.Delivered, OrderStatus.Cancelled].includes(orderStatus) && isLast}
	<div class="border-t-1 flex w-full justify-center border-gray-200 py-4 lg:hidden">
		<Button variant="primary" icon={cake} iconClass="h-5 w-5" on:click={onRepeatOrder}>Znovu objednat</Button>
	</div>
{/if}
